import React from "react";
import T from "prop-types";

import { Field } from "2g-form";

import { useServerMessage, useToLocaleDateTime } from "b2b/i18n";

import useMessages from "./i18n/useMessages";
import resolveInputProps from "./resolveInputProps";

export function KonfiguracniParamteryEditaceItem({
  konfiguracniParametr,
  index
}) {
  const { labelLastModification } = useMessages();
  const message = useServerMessage();
  const toLocaleDateTime = useToLocaleDateTime();
  return (
    <div className="b2b-KonfiguracniParametryEditaceItem">
      <div>
        <label>{message(konfiguracniParametr, "vyznam")}</label>
        <div className="b2b-KonfiguracniParametryEditaceItem-datumUprava">
          {`${labelLastModification()} ${toLocaleDateTime(
            konfiguracniParametr.datumUprava
          )}`}
        </div>
      </div>
      <Field
        {...resolveInputProps(konfiguracniParametr.kod.typ)}
        path={["konfiguracniParametry", index, "hodnotaCs"]}
      />
    </div>
  );
}

KonfiguracniParamteryEditaceItem.propTypes = {
  index: T.number,
  konfiguracniParametr: T.shape({
    kod: T.string,
    vyznamCs: T.string,
    vyznamEn: T.string,
    hodnotaCs: T.string,
    hodnotaEn: T.string,
    datumUprava: T.number
  })
};

export default React.memo(KonfiguracniParamteryEditaceItem);
